import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import GoBackBtn from "../../../components/buttons/GoBackBtn";
import { BasicContext } from "../../../App";
import { postMethod } from "../../../requests";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPercent, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { BackOfficeContext } from "../BackOffice";
import { Checkbox, FormField, Radio } from "semantic-ui-react";
import DatePicker, { registerLocale } from "react-datepicker";
import pl from "date-fns/locale/pl";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";
registerLocale("pl", pl);

const CreateDiscountCode = () => {
    const { t } = useTranslation();
    const { checkServerData, changeView, setAlerts, showView } = useContext(BasicContext);
    const { setDiscoutCodesList } = useContext(BackOfficeContext);
    const [blockForm, setBlockForm] = useState(false);
    const [formChanged, setFormChanged] = useState(false);
    const [code, setCode] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        if (code.discount_code_name.length === 0 || !code.discount_code_name.replace(/\s+/, "")) {
            $("#codeName").addClass("is-invalid");
            errors.push(t("error.noCodeName"));
        }
        if ((code.discount_value && code.discount_rate) || (!code.discount_value && !code.discount_rate)) {
            $("#codeValue").addClass("is-invalid");
            $("#codeRate").addClass("is-invalid");
            errors.push(t("error.oneOfCodesValueMustBeFilled"));
        } else if (code.discount_value && (code.discount_value.length > 11 || code.discount_value <= 0 || code.discount_value === "0")) {
            $("#codeValue").addClass("is-invalid");
            errors.push(t("error.invalidCodeValue"));
        } else if (code.discount_rate && (code.discount_rate.length > 11 || code.discount_rate <= 0 || code.discount_rate === "0")) {
            $("#codeRate").addClass("is-invalid");
            errors.push(t("error.invalidCodeRate"));
        }
        if (!code.discount_multiple_usage) {
            $("#codeMultipleUsage").addClass("is-invalid");
            errors.push(t("error.noCodeMultipleUsage"));
        }

        if (code.discount_code_quantity && (code.discount_code_quantity.length < 1 || code.discount_code_quantity.length > 11 || code.discount_code_quantity < 1)) {
            $("#codeQuantity").addClass("is-invalid");
            errors.push(t("error.invalidCodeQuantity"));
        }
        if (!code.discount_code_start_date) {
            $("#codeStartDate").addClass("is-invalid");
            errors.push(t("error.noCodeStartDate"));
        }

        if (code.discount_code_descr && (code.discount_code_descr.length === 0 || !code.discount_code_descr.replace(/\s+/, ""))) {
            $("#codeDescription").addClass("is-invalid");
            errors.push(t("error.invalidCodeDescription"));
        } else if (code.discount_code_descr && code.discount_code_descr.length > 255) {
            $("#codeDescription").addClass("is-invalid");
            errors.push(t("error.codeDescriptionTooLong"));
        }

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e, i) => {
                list.push({ variant: "danger", message: e, id: i });
            });
            setAlerts(list);
        } else {
            setAlerts([{ variant: "info", message: t(`info.${showView.params.codeID ? "updatingDiscountCode" : "creatingDiscountCode"}`) }]);
            setBlockForm(true);
            addEditCode();
        }
    };

    const addEditCode = async () => {
        const res = await postMethod("/create-discount-code", {
            code: code,
            codeID: showView.params.codeID,
        });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "addedDC" }]);
            setDiscoutCodesList(null);
            changeView({ nav: "codes", sub: "discountCodesList" });
        } else setBlockForm(false);
    };

    const autoResize = (textarea) => {
        textarea.style.height = "auto"; // Resetowanie wysokości
        textarea.style.height = `${textarea.scrollHeight}px`; // Ustawienie wysokości na podstawie zawartości
    };

    useEffect(() => {
        if (!loading) {
            const textarea = document.getElementById("codeDescription");
            autoResize(textarea);
            textarea.addEventListener("input", function () {
                autoResize(this);
            });
        }
        // eslint-disable-next-line
    }, [loading]);

    useEffect(() => {
        if (code) {
            setLoading(false);
        }
        // eslint-disable-next-line
    }, [code]);

    const setHeight = () => {
        $(`#addEditDiscountCode`).css("min-height", `${window.innerHeight - 61 - $("#goBackBtn").outerHeight() - $("#footerMain").outerHeight()}px`);
    };

    const getDiscountCodeData = async () => {
        const res = await postMethod("/get-discount-code-data", { codeID: showView.params.codeID });
        if (checkServerData(res)) {
            setCode(res.data.code);
            setLoading(false);
        }
    };

    useEffect(() => {
        setHeight();
        if (!showView.params.codeID) {
            setCode({
                discount_code_name: "",
                discount_code_descr: "",
                discount_value: "",
                discount_rate: "",
                discount_code_quantity: "",
                discount_multiple_usage: false,
                discount_code_start_date: new Date(),
                discount_code_end_date: null,
                discount_code_active: true,
                discount_code_visible: true,
            });
            setLoading(false);
        } else getDiscountCodeData();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <GoBackBtn />
            <Container fluid="lg" id="addEditDiscountCode">
                <Row>
                    <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                        <h1 className="h4 d-inline-block m-0 pt-2">{t(`codes.${showView.params.codeID ? "edit" : "createNew"}DiscountCode`)}</h1>
                    </Col>
                    {loading ? (
                        <Col xs={12} className="my-5 text-center">
                            <p className="h4">
                                {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                            </p>
                        </Col>
                    ) : (
                        <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                            <Form onSubmit={checkValidation} autoComplete="off">
                                <Row>
                                    <Col xs={12} lg={6}>
                                        <Form.Group className="mb-3" controlId="codeName">
                                            <Form.Label className="w-100">
                                                {t(`codes.codeName`)} <span className="req">*</span>
                                                <p className="text-small mt-2">{t("codes.codeNameHelper")}</p>
                                            </Form.Label>
                                            <Form.Control
                                                value={code.discount_code_name}
                                                placeholder={t("codes.typeCodeName")}
                                                onChange={(e) => {
                                                    setCode({ ...code, discount_code_name: e.target.value });
                                                    $("#codeName").removeClass("is-invalid");
                                                    setFormChanged(true);
                                                }}
                                                disabled={blockForm}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6} lg={3}>
                                        <Form.Group className="mb-3" controlId="codeValue">
                                            <Form.Label className="w-100">
                                                {t(`codes.codeValue`)}
                                                <span className="req">*</span>
                                            </Form.Label>

                                            <InputGroup className="mb-3">
                                                <Form.Control
                                                    placeholder={t("typeAmount")}
                                                    aria-label="codeValue"
                                                    aria-describedby="codeValueAddon"
                                                    value={code.discount_value}
                                                    onChange={(e) => {
                                                        setCode({ ...code, discount_value: e.target.value, discount_rate: "" });
                                                        $("#codeValue").removeClass("is-invalid");
                                                        $("#codeRate").removeClass("is-invalid");
                                                        setFormChanged(true);
                                                    }}
                                                    disabled={blockForm}
                                                />
                                                <InputGroup.Text id="codeValueAddon">{t("currency")}</InputGroup.Text>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6} lg={3}>
                                        <Form.Group className="mb-3" controlId="codeRate">
                                            <Form.Label className="w-100">
                                                {t(`codes.codeRate`)}
                                                <span className="req">*</span>
                                            </Form.Label>
                                            <InputGroup className="mb-3">
                                                <Form.Control
                                                    placeholder={t("typePercent")}
                                                    aria-label="codeRate"
                                                    aria-describedby="codeRateAddon"
                                                    value={code.discount_rate}
                                                    onChange={(e) => {
                                                        setCode({ ...code, discount_rate: e.target.value, discount_value: "" });
                                                        $("#codeValue").removeClass("is-invalid");
                                                        $("#codeRate").removeClass("is-invalid");
                                                        setFormChanged(true);
                                                    }}
                                                    disabled={blockForm}
                                                />
                                                <InputGroup.Text id="codeRateAddon">
                                                    <FontAwesomeIcon icon={faPercent} />
                                                </InputGroup.Text>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} lg={5}>
                                        <Form.Group id={`codeMultipleUsage`} className="mb-3">
                                            <Form.Label className="w-100">
                                                {t(`codes.codeType`)} <span className="req">*</span>
                                                <p className="mt-2 text-small">{t("codes.codeMultipleUsageHelper")}</p>
                                            </Form.Label>
                                            <FormField>
                                                <Radio
                                                    disabled={blockForm}
                                                    label={t("codes.singleUsageCode")}
                                                    name="radioGroup"
                                                    value="single"
                                                    checked={code.discount_multiple_usage === "single"}
                                                    onChange={() => {
                                                        setCode({ ...code, discount_multiple_usage: "single" });
                                                        setFormChanged(true);
                                                    }}
                                                />
                                            </FormField>
                                            <FormField>
                                                <Radio
                                                    disabled={blockForm}
                                                    label={t("codes.multipleUsageCode")}
                                                    name="radioGroup"
                                                    value="multiple"
                                                    checked={code.discount_multiple_usage === "multiple"}
                                                    onChange={() => {
                                                        setCode({ ...code, discount_multiple_usage: "multiple" });
                                                        setFormChanged(true);
                                                    }}
                                                />
                                            </FormField>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6} lg={3}>
                                        <Form.Group controlId="codeStartDate">
                                            <Form.Label>
                                                {t("codes.codeStartDate")}:<span className="req">*</span>
                                            </Form.Label>
                                            <DatePicker
                                                autoComplete="off"
                                                selected={code.discount_code_start_date}
                                                onChange={(date) => {
                                                    setCode({ ...code, discount_code_start_date: date });
                                                    $("#codeStartDate").removeClass("is-invalid");
                                                    setFormChanged(true);
                                                }}
                                                showIcon
                                                locale="pl"
                                                dateFormat="yyyy-MM-dd"
                                                icon={<FontAwesomeIcon icon={faCalendar} />}
                                                className="mb-2 mb-lg-3"
                                                placeholderText={t("choose")}
                                                id="classStartDate"
                                                disabled={blockForm}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6} lg={3}>
                                        <Form.Group controlId="codeEndDate">
                                            <Form.Label>{t("codes.codeEndDate")}:</Form.Label>
                                            <DatePicker
                                                autoComplete="off"
                                                selected={code.discount_code_end_date}
                                                onChange={(date) => {
                                                    setCode({ ...code, discount_code_end_date: date });
                                                    $("#codeEndDate").removeClass("is-invalid");
                                                    setFormChanged(true);
                                                }}
                                                showIcon
                                                locale="pl"
                                                dateFormat="yyyy-MM-dd"
                                                icon={<FontAwesomeIcon icon={faCalendar} />}
                                                className="mb-2 mb-lg-3"
                                                placeholderText={t("choose")}
                                                id="classEndDate"
                                                disabled={blockForm}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} className="d-lg-none">
                                        <p className="text-small mb-3">{t("codes.emptyEndDate")}</p>
                                    </Col>
                                    <Col xs={12} lg={7}>
                                        <Form.Group className="mb-3" controlId="codeDescription">
                                            <Form.Label className="w-100">{t(`codes.codeDescription`)}</Form.Label>
                                            <Form.Control
                                                value={code.discount_code_descr}
                                                as="textarea"
                                                placeholder={t("codes.codeDescriptionPlaceholder")}
                                                onChange={(e) => {
                                                    setCode({ ...code, discount_code_descr: e.target.value });
                                                    $("#codeDescription").removeClass("is-invalid");
                                                    setFormChanged(true);
                                                }}
                                                disabled={blockForm}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} lg={4}>
                                        <Form.Group className="mb-3" controlId="codeQuantity">
                                            <Form.Label className="w-100">
                                                {t(`codes.codeQuantity`)}
                                                <p className="text-small mt-2">{t("codes.codeQuantityHelper")}</p>
                                            </Form.Label>
                                            <Form.Control
                                                type="number"
                                                value={code.discount_code_quantity}
                                                placeholder={t("typeNumber")}
                                                onChange={(e) => {
                                                    setCode({ ...code, discount_code_quantity: e.target.value });
                                                    $("#codeQuantity").removeClass("is-invalid");
                                                    setFormChanged(true);
                                                }}
                                                disabled={blockForm}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} lg={6}>
                                        <Form.Group className="mb-3" controlId={`codeActive`}>
                                            <Checkbox
                                                toggle
                                                label={t("codes.codeIsActive")}
                                                checked={code.discount_code_active}
                                                disabled={blockForm}
                                                onChange={() => {
                                                    setCode({ ...code, discount_code_active: !code.discount_code_active });
                                                    $("#codeActive").removeClass("is-invalid");
                                                    setFormChanged(true);
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} lg={6}>
                                        <Form.Group className="mb-3" controlId={`codeVisible`}>
                                            <Checkbox
                                                toggle
                                                label={t("codes.codeIsVisible")}
                                                checked={code.discount_code_visible}
                                                disabled={blockForm}
                                                onChange={() => {
                                                    setCode({ ...code, discount_code_visible: !code.discount_code_visible });
                                                    $("#codeVisible").removeClass("is-invalid");
                                                    setFormChanged(true);
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="sticky-bottom bg-light-primary" style={{ zIndex: 1 }}>
                                    <Col xs={12} className="my-4">
                                        <Button variant="primary" type="submit" disabled={blockForm || !formChanged}>
                                            {t(`codes.${showView.params.codeID ? "update" : "create"}Code`)}
                                        </Button>

                                        <Button variant="outline-secondary" className="float-end" onClick={() => changeView({ nav: "codes", sub: "discountCodesList" })}>
                                            {t("cancel")}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    )}
                </Row>
            </Container>
        </Fragment>
    );
};

export default CreateDiscountCode;
